// Use this file to export React client components (e.g. those with 'use client' directive) or other non-server utilities
import colors from './lib/scss/abstracts/_palette.module.scss';
import style from './lib/scss/abstracts/_breakpoints.module.scss';

export const breakpoints = style;
export const palette = colors;

export * from './lib/assets';
